export default __webpack_public_path__ + "static/Sinwattana_logo-e7e228f23c17d5557e8a45b983d5159d.png";